import { createContext } from 'react';
var ColorAxisContext = createContext();
ColorAxisContext.displayName = 'ColorAxisContext';
export default ColorAxisContext;